import React from 'react';

import CarouselDonationCards from '@/core/components/CarouselDonationCards';
import Store from '@/core/lib/new-architecture/store';
import Routes from '@/core/lib/router/routes';
import { useTranslationContext } from '@/core/lib/translation/translation.context';

interface DonationsUserProps {
  uuid: string | undefined;
  idFiltered?: number;
}

const DonationsUser: React.FC<DonationsUserProps> = ({ uuid, idFiltered }) => {
  const { t } = useTranslationContext(['donation-detail']);
  const { data: user } = Store.user.usePublicProfile(uuid);

  if (!user) return null;

  const donations = user.getDonations().filter(donation => donation.getId() !== idFiltered);

  return !donations.length ? null : (
    <CarouselDonationCards
      title={t(user.getPrivateInfo() ? 'donations-list-title-mine' : 'donations-list-title', { username: user.getPublicInfo().username })}
      donations={donations}
      href={new Routes.PublicProfileRoute(user.uuid)}
      hideUser
    />
  );
};

export default DonationsUser;
